
import React from "react";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";
import { h } from "@fullcalendar/core/preact.js";

export const TablePayment = ({ reportData, columns }) => {
  if (!reportData) {
    return null;
  }

  const { contract, holders, products, installments, totals, footer } = reportData;

  const mainColumns = [
    "Ano",
    "Nº",
    "Descrição",
    "Vencimento",
    "Valor Orig.",
    "Pago",
    "Dt. Pag",
    "Correção",
    "Multa",
    "Juros",
    "Acrés.",
    "Desc.",
    "Desc. Ant",
    "Método"
  ];


  return (
    <div className="my-3 d-flex flex-column align-items-center text-start overflow-hidden">
      <table style={{ width: "99%", marginBottom: 8 }}>
        <tbody>
          <tr className="fw-bolder" style={{ backgroundColor: "#b8b8b8", color: "#2D2D2D" }}>
            <td colSpan={mainColumns.length}>
              Contrato #{contract?.number} - {contract?.enterprise} | Status: {contract?.status_description} | Data da Venda: {contract?.sale_date}
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ width: "99%", marginBottom: 8 }}>
  {holders && holders.length > 0 && (
    <div className="mb-3">
      <div>
        <span className="fw-bold">Cliente:</span> {holders[0].name}
      </div>
      <div>
        <span className="fw-bold">CPF/CNPJ:</span> {holders[0].document}
      </div>
    </div>
  )}

  {holders && holders.length > 0 && holders[0].address && holders[0].address.street && (
    <div className="mb-3">
      <div className="d-flex flex-wrap align-items-center">
        <div className="me-4">
          <span className="fw-bold">End.:</span>
          {` ${holders[0].address.street.address || ""}`}
          {holders[0].address.street.num ? `, Nº ${holders[0].address.street.num}` : ""}
          {holders[0].address.street.complement ? `, ${holders[0].address.street.complement}` : ""}
        </div>
        <div>
          <span className="fw-bold">Bairro:</span> {holders[0].address.street.neighborhood || ""}
        </div>
      </div>
      <div className="d-flex flex-wrap align-items-center mt-1">
        <div className="me-4">
          <span className="fw-bold">Cidade:</span> {holders[0].address.street.city || ""}
        </div>
        <div className="me-4">
          <span className="fw-bold">UF:</span> {holders[0].address.street.state || ""}
        </div>
        <div>
          <span className="fw-bold">CEP:</span> {holders[0].address.street.cep || ""}
        </div>
      </div>
    </div>
  )}

  {holders && holders.length > 0 && holders[0].phones && holders[0].phones.length > 0 && (
    <div className="d-flex flex-wrap align-items-center mb-3">
      <span className="fw-bold me-2">Fones:</span>
      {holders[0].phones.map((phone, idx) => (
        <span key={idx} className="me-3">
          {phone.type_number === 1 && <span className="fw-bold">Celular:</span>}
          {phone.type_number === 2 && <span className="fw-bold">Residencial:</span>}
          {phone.type_number === 3 && <span className="fw-bold">Comercial:</span>}
          {` ${phone.number}`}
        </span>
      ))}
    </div>
  )}

  {products && products.length > 0 && (
    <div className="mt-2 pt-2 border-top">
      <span className="fw-bold">Produtos:</span> {products.map((p, i) => `${p.description}${p.identifier ? ` (${p.identifier})` : ''} - Valor do Lote: ${formatCurrency(p.total)}`).join(" | ")}
    </div>
  )}
       
      </div>
      <table style={{ width: "99%" }}>
        <tbody>

          {installments && installments.length > 0 ? (
            installments.map((yearData, idx) => (
              <React.Fragment key={yearData.year}>
                <tr className="fw-bolder" style={{ backgroundColor: "#eaeaea", color: "#2D2D2D" }}>
                  <td colSpan={mainColumns.length} style={{ textAlign: 'left' }}>
                    Ano: <b>{yearData.year}</b> &nbsp;&nbsp;   Total pago: <b>{formatCurrency(yearData.totals?.paid)}</b>
                  </td>
                </tr>
                <tr className="fw-bolder" style={{ backgroundColor: "#b8b8b8", color: "#2D2D2D" }}>
                  {mainColumns.map((col, i) => (
                    <td key={i} className="border border-white border-1 p-1 text-center" style={{ maxWidth: "72px", overflow: "hidden", textOverflow: "ellipsis" }}>{col}</td>
                  ))}
                </tr>
                {yearData.installments && yearData.installments.length > 0 ? (
                  yearData.installments.map((installment, i) => (
                    <tr key={i}>
                      <td className="text-center border">{yearData.year}</td>
                      <td className="text-center border">{installment.number}</td>
                      <td className="text-center border">{installment.description}</td>
                      <td className="text-center border">{formatDate(installment.due_date)}</td>
                      <td className="text-center border">{formatCurrency(installment.value)}</td>
                      <td className="text-center border">{formatCurrency(installment.paid_value)}</td>
                      <td className="text-center border">{formatDate(installment.payment_date)}</td>
                      <td className="text-center border">{formatCurrency(installment.correction)}</td>
                      <td className="text-center border">{formatCurrency(installment.fine)}</td>
                      <td className="text-center border">{formatCurrency(installment.interest)}</td>
                      <td className="text-center border">{formatCurrency(installment.addition)}</td>
                      <td className="text-center border">{formatCurrency(installment.discount)}</td>
                      <td className="text-center border">{formatCurrency(installment.advance_discount)}</td>
                      <td className="text-center border">{installment.payment_method}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={mainColumns.length} className="text-center">Nenhuma parcela paga encontrada para este ano.</td>
                  </tr>
                )}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan={mainColumns.length} className="text-center">Nenhuma parcela paga encontrada.</td>
            </tr>
          )}


          <tr className="fw-bolder" style={{ fontSize: "11px", translate: "0px 5px" }}>
            <td colSpan={2}>Totais</td>
            <td>Recebido: {formatCurrency(totals?.received)}</td>
            <td>Não compensado: {formatCurrency(totals?.not_compensated)}</td>
            <td>Desconto: {formatCurrency(totals?.discount_total)}</td>
            <td>Multa: {formatCurrency(totals?.fine_total)}</td>
            <td>Juros: {formatCurrency(totals?.interest_total)}</td>
          </tr>

          <tr className="fw-bolder" style={{ fontSize: "11px", translate: "0px 2px" }}>
            <td colSpan={mainColumns.length}>
              Parcelas totais: {footer?.summary?.installments?.total} | Parcelas em atraso: {footer?.summary?.installments?.overdue} | Parcelas antecipadas: {footer?.summary?.installments?.advance} | Recebido (%): {footer?.summary?.percentage?.received}% | A receber (%): {footer?.summary?.percentage?.to_receive}% 
            </td>
          </tr>

          <tr className="fw-bolder" style={{ fontSize: "11px", translate: "0px 2px" }}>
            <td colSpan={mainColumns.length}>Total de Registros: {installments ? installments.reduce((acc, y) => acc + (y.installments?.length || 0), 0) : 0}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}